import React from 'react'
import NeoSans from '../fonts/NeoSansStd-Regular.otf'
import NeoSansBold from '../fonts/NeoSansW1G-Bold.otf'
import { Document, Page, View, Text, StyleSheet, pdf, Image, Font, Link } from '@react-pdf/renderer'
import durchlaufanlagen from '../img/durchlaufanlagen.png'
import heatevents from '../img/heatevents.png'
import deckblatt from '../img/deckblatt_cropped.png'
import logoCombined from '../img/logos_kombiniert_white.png'


Font.register({
  family: 'Neo-sans', fonts: [
    { src: NeoSans },
    { src: NeoSansBold, fontWeight: 700 }
  ]
})

Font.registerHyphenationCallback(word => {
  const cut = word.indexOf('@')
  const parts = [word.substring(0, cut), word.substring(cut)]
  return parts
})

const renderCharts = (idealHeatEvent, scoreChart, footprintChart, powerChartUrl, outputChartUrl, investChartUrl) => {
  return idealHeatEvent ? (
    <Page style={[styles.page, styles.largeSpaceAbove]}>
      <View style={styles.section}>
        <Text style={styles.h2}>3 Ihr optimales Ofenkonzept</Text>
        <Text style={[styles.bold, styles.smallSpaceAbove]}>Gesamtpunkte:</Text>
        <Text>Gemäß Ihrer Zielrichtung für das Projekt haben wir die ermittelten Ergebnisse gewichtet und einen Score ohne Einheit gebildet. Dieser stellt dar, wie gut die jeweiligen Ofenkonzepte zu Ihrer Zielrichtung passen.</Text>
        <Image style={[styles.smallSpaceAbove, styles.colTen, { margin: '0px auto' }]} src={scoreChart} />
        <Text style={styles.bold}>Footprint:</Text>
        <Text>Dargestellt ist die geschätzte Aufstellfläche der jeweiligen Anlagen in m². Noch nicht berücksichtigt sind Wege und Wartungszugänge.</Text>
        <Image style={[styles.smallSpaceAbove, styles.colTen, { margin: '0px auto' }]} src={footprintChart} />
        <Text style={styles.bold}>Energiebedarf:</Text>
        <Text>Ermittelt wurde die elektrische Heizleistung in kWh.</Text>
        <Image style={[styles.smallSpaceAbove, styles.colTen, { margin: '0px auto' }]} src={powerChartUrl} />
        <Text style={styles.bold}>Produktionsmenge:</Text>
        <Text>Abhängig vom Konzept ergeben sich unterschiedliche jährliche Ausbringungsmengen in Stück. Dieser Kalkulation liegen 250 Arbeitstage mit 2 Schichten zu je 8 Produktivstunden zu Grunde. </Text>
        <Image style={[styles.smallSpaceAbove, styles.colTen, { margin: '0px auto' }]} src={outputChartUrl} />
        <Text style={styles.bold}>Investvolumen:</Text>
        <Text>Es ist jeweils das gesamte zu erwartende Investitionsvolumen je Lösung in Euro dargestellt. Bitte berücksichtigen Sie, dass es sich hierbei um einen unverbindlichen Richtwert handelt.</Text>
        <Image style={[styles.smallSpaceAbove, styles.colTen, { margin: '0px auto' }]} src={investChartUrl} />
      </View>
    </Page>
  ) : (
    <>
      <Page style={[styles.page, styles.largeSpaceAbove]}>
        <View style={styles.section}>
          <Text style={styles.h2}>3 Ihr optimales Ofenkonzept</Text>
          <Text style={[styles.smallSpaceAbove]}>Im Rahmen dieser groben ersten Auslegung, konnte kein passender Kammerofen aus unserem Standardprogramm der Baureihe HeatEvent identifiziert werden. Gerne prüfen unsere Spezialisten gemeinsam mit Ihnen die Einsatzmöglichkeiten eines auf Ihren Anwendungsfall angepassten Kammerofens. </Text>
          <Text style={[styles.bold, styles.smallSpaceAbove]}>Gesamtpunkte:</Text>
          <Text>Gemäß Ihrer Zielrichtung für das Projekt haben wir die ermittelten Ergebnisse gewichtet und einen Score ohne Einheit gebildet. Dieser stellt dar, wie gut die jeweiligen Ofenkonzepte zu Ihrer Zielrichtung passen.</Text>
          <Image style={[styles.smallSpaceAbove, styles.colTen, { margin: '0px auto' }]} src={scoreChart} />
          <Text style={styles.bold}>Footprint:</Text>
          <Text>Dargestellt ist die geschätzte Aufstellfläche der jeweiligen Anlagen in m². Noch nicht berücksichtigt sind Wege und Wartungszugänge.</Text>
          <Image style={[styles.smallSpaceAbove, styles.colTen, { margin: '0px auto' }]} src={footprintChart} />
          <Text style={styles.bold}>Energiebedarf:</Text>
          <Text>Ermittelt wurde die elektrische Heizleistung in kWh.</Text>
          <Image style={[styles.smallSpaceAbove, styles.colTen, { margin: '0px auto' }]} src={powerChartUrl} />
          <Text style={styles.bold}>Produktionsmenge:</Text>
          <Text>Abhängig vom Konzept ergeben sich unterschiedliche jährliche Ausbringungsmengen in Stück. Dieser Kalkulation liegen 250 Arbeitstage mit 2 Schichten zu je 8 Produktivstunden zu Grunde. </Text>
          <Image style={[styles.smallSpaceAbove, styles.colTen, { margin: '0px auto' }]} src={outputChartUrl} />
        </View>
      </Page>
      <Page style={[styles.page, styles.largeSpaceAbove]} >
        <View style={styles.section}>
          <Text style={styles.bold}>Investvolumen:</Text>
          <Text>Es ist jeweils das gesamte zu erwartende Investitionsvolumen je Lösung in Euro dargestellt. Bitte berücksichtigen Sie, dass es sich hierbei um einen unverbindlichen Richtwert handelt.</Text>
          <Image style={[styles.smallSpaceAbove, styles.colTen, { margin: '0px auto' }]} src={investChartUrl} />
        </View>
      </Page >
    </>
  )
}

const styles = StyleSheet.create({

  // Typo
  page: {
    fontFamily: 'Neo-sans',
    flexDirection: 'column',
    fontSize: "12pt"
  },
  h1: {
    fontSize: "24pt",
  },
  h2: {
    fontSize: "18pt",
    fontWeight: 700
  },
  bold: {
    fontWeight: 700
  },
  link: {
    textDecoration: 'none'
  },

  // Elements
  section: {
    margin: 10,
    marginBottom: 0,
    padding: 10,
  },
  paragraph: {
    marginTop: 5,
    marginBottom: 5,
  },
  chart: {
    width: "400px"
  },
  table: {
    border: "1px solid black"
  },
  tableRow: {
    padding: '5px',
  },
  tableCellLeft: {
    borderLeft: "1px solid black"
  },
  tableCellTop: {
    borderTop: "1px solid black"
  },
  list: {
    flexDirection: 'column',
    width: 400
  },
  listEntry: {
    flexDirection: 'row',
    marginBottom: 4
  },
  listPoint: {
    marginHorizontal: 8
  },

  // Spacing
  largeSpaceAbove: {
    marginTop: "20px"
  },
  smallSpaceAbove: {
    marginTop: "10px"
  },
  spaceBefore: {
    marginLeft: "5px"
  },
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between'
  },
  colTwelve: {
    width: "100%",
  },
  colTen: {
    width: "80%"
  },
  colEight: {
    width: "60%",
  },
  colSix: {
    width: "45%",
  },
  colFour: {
    width: "30%"
  }
})

const PdfDocument = ({
  motivationChart, scoreChart, footprintChart, sliderPoints,
  material, colors, surface,
  geometry, length, width, height, weight,
  quantity, zone1Energy, zone2Energy,
  processTemp, ambientTemp,
  heatTime, holdTime, processChartUrl, powerChartUrl, outputChartUrl, investChartUrl, idealHeatEvent }) => {

  let motivations = []
  for (let motivation in sliderPoints) {
    motivations.push([motivation, sliderPoints[motivation]])
  }
  motivations.sort((a, b) => b[1] - a[1])

  let firstMotivation = '';
  switch (motivations[0][0]) {
    case 'Fläche':
      firstMotivation = 'der optimalen Ausnutzung der verfügbaren Fläche'
      break;
    case 'Ausbringung':
      firstMotivation = 'der Steigerung der Ausbringung'
      break;
    case 'Energiekosten':
      firstMotivation = 'einem optimierten Energieverbrauch und geringem CO²-Footprint'
      break;
    case 'Investvolumen':
      firstMotivation = 'einer möglichst günstigen Realisierung'
      break;
    default:
      firstMotivation = ''
      break;
  }

  let secondMotivation = '';
  switch (motivations[1][0]) {
    case 'Fläche':
      secondMotivation = 'der optimalen Ausnutzung der verfügbaren Fläche'
      break;
    case 'Ausbringung':
      secondMotivation = 'der Steigerung der Ausbringung'
      break;
    case 'Energiekosten':
      secondMotivation = 'einem optimierten Energieverbrauch und geringem CO²-Footprint'
      break;
    case 'Investvolumen':
      secondMotivation = 'einer möglichst günstigen Realisierung'
      break;
    default:
      secondMotivation = ''
      break;
  }

  return (
    <Document>

      {/* TODO: Seite 1 Deckblatt */}
      <Page style={styles.page}>
        <View style={{ position: 'absolute', height: '100%' }}>
          <Image source={deckblatt} />
          <Image source={logoCombined} style={{ position: 'absolute', top: '35px', width: "400px" }} />
        </View>
        <View style={[styles.section, { top: '500px', position: 'absolute', right: "350px" }]}>
          <View style={{ alignItems: 'flex-end', color: 'white' }}>
            <Text style={[styles.h1, styles.colEight, { textAlign: 'right' }]}>Selektion eines geeigneten Anlagenkonzepts für Ihren thermischen Prozess</Text>
            <Text style={[styles.h1, styles.bold, styles.largeSpaceAbove, { textAlign: 'right' }, styles.colEight]}>Geschäftsbereich</Text>
            <Text style={[styles.h1, styles.bold, styles.colEight, { textAlign: 'right' }]}>Heat Technology</Text>
          </View>
        </View>
      </Page>

      {/* TODO: Seite 2 Inhaltsverzeichnis */}

      {/* Seite 3 Einleitung */}
      <Page style={[styles.page, styles.largeSpaceAbove]}>

        {/* Allgemeine Informationen */}
        <View style={styles.section}>
          <Text style={styles.h2}>1 Allgemeine Informationen</Text>
          <Text style={styles.paragraph}>Im Bereich der industriellen Wärmetechnik entwickeln, planen und produzieren wir mit einem erfahrenen Team zuverlässige Anlagen für nahezu jeden Anwendungsbereich. In unserem Portfolio finden Sie u.a. eine breite Palette an Wärme- und Trockenschränken, Industrieöfen, Reinraumtrocknern, Heißluftsterilisatoren, Vakuumtrocknern, Infrarot- und Durchlauföfen sowie die zukunftsweisende Mikrowellentechnologie.</Text>
          <Text style={styles.paragraph}>Neben einer umfassenden Auswahl an Serienprodukten liegt unser Fokus auf der Realisierung von kundenspezifischen, prozessintegrierten Lösungen. </Text>
          <Text style={styles.paragraph}>Bitte berücksichtigen Sie die Tatsache, dass die hier vorliegenden Ergebnisse auf einer Vielzahl von Annahmen beruhen um eine erste Indikation zu ermöglichen. Es handelt sich dementsprechend um eine starke Vereinfachung. Wir freuen uns daher im Dialog mit Ihnen diese erste Kalkulation zu verfeinern.</Text>
          <Text style={[styles.paragraph, styles.bold]}>Gemeinsam mit Ihnen entwickeln wir Ihren Prozess unter realen Bedingungen weiter. Im Anwendungszentrum unseres Partners Heraeus Noblelight in Kleinostheim haben wir kurzfristig die Möglichkeit Ihren Prozess in einer kombinierten Infrarot und Umluftanlage zu optimieren.</Text>

          <View style={[styles.row, styles.largeSpaceAbove]}>

            <View style={[styles.colSix, { flexDirection: 'column' }]}>
              <Text style={styles.paragraph}>Sprechen Sie unsere Spezialisten an:</Text>
              <Text>&nbsp;</Text>
              <View>
                <Text style={[styles.bold, styles.paragraph]}>Sascha Junker</Text>
                <Text style={styles.paragraph}>Sales Administrator Custom Solutions Heat Technology</Text>
                <Link style={styles.link} src="mailto:sascha.junker@weiss-technik.com">sascha.junker@weiss-technik.com</Link>
                <Text>&nbsp;</Text>
              </View>
              <View>
                <Text style={[styles.bold, styles.paragraph, styles.smallSpaceAbove]}>Martin Gertler</Text>
                <Text style={styles.paragraph}>Head of Sales Heat Technology</Text>
                <Link style={styles.link} src="mailto:martin.gertler@weiss-technik.com">martin.gertler@weiss-technik.com</Link>
              </View>
            </View>

            <View style={[styles.colSix, { flexDirection: 'column' }]}>
              <Text style={styles.paragraph}>Sprechen Sie unsere Infrarot-Spezialisten an:</Text>
              <Text>&nbsp;</Text>
              <View>
                <Text style={[styles.bold, styles.paragraph]}>Jörg Wöll</Text>
                <Text style={styles.paragraph}>Head of Sales Germany</Text>
                <Link style={styles.link} src="mailto:joerg.woell@heraeus.com">joerg.woell@heraeus.com</Link>
                <Text>&nbsp;</Text>
                <Text>&nbsp;</Text>
              </View>
              <View>
                <Text style={[styles.bold, styles.paragraph, styles.smallSpaceAbove]}>Jana Sundararajan</Text>
                <Text style={styles.paragraph}>Head of Custom Design Engineering</Text>
                <Link style={styles.link} src="mailto:jana.sundararajan@heraeus.com">jana.sundararajan@heraeus.com</Link>
              </View>
            </View>

          </View>

        </View>

      </Page>

      {/* Seite 4 Eingaben und Prozessparameter */}
      <Page style={[styles.page, styles.largeSpaceAbove]}>

        {/* Eingaben und Parameter */}
        <View style={styles.section}>
          <Text style={styles.h2}>2 Ihre Eingaben und Prozessparameter</Text>
          <Text style={[styles.paragraph, styles.bold]}>2.1 Zielrichtung des Projekts</Text>
          <Text style={styles.paragraph}>Der Fokus Ihres Vorhabens liegt auf {firstMotivation}. Weiterhin liegt Ihr Augenmerk auf {secondMotivation}.</Text>
          <Image style={[styles.colEight, { margin: '0px auto' }]} src={motivationChart} />
        </View>

        {/* Werkstoff */}
        <View style={styles.section}>
          <Text style={[styles.paragraph, styles.bold]}>2.2 Primäre technische Eigenschaften der Produkte</Text>
          <View style={styles.table}>
            <View style={styles.row}>
              <Text style={[styles.colSix, styles.tableRow]}>Werkstoff</Text>
              <Text style={[styles.colSix, styles.tableCellLeft, styles.tableRow]}>{material}</Text>
            </View>
            <View style={[styles.row, styles.tableCellTop]}>
              <Text style={[styles.colSix, styles.tableRow]}>Farbe</Text>
              <Text style={[styles.colSix, styles.tableCellLeft, styles.tableRow]}>
                {colors.length === 1 ? colors[0] : colors.map((color, index) => {
                  let colorStr = index === colors.length - 1 ? color : color + ", "
                  return colorStr
                })}
              </Text>
            </View>
            <View style={[styles.row, styles.tableCellTop]}>
              <Text style={[styles.colSix, styles.tableRow]}>Oberfläche</Text>
              <Text style={[styles.colSix, styles.tableCellLeft, styles.tableRow]}>{surface}</Text>
            </View>
            <View style={[styles.row, styles.tableCellTop]}>
              <Text style={[styles.colSix, styles.tableRow]}>Geometrie</Text>
              <Text style={[styles.colSix, styles.tableCellLeft, styles.tableRow]}>{geometry}</Text>
            </View>
            <View style={[styles.row, styles.tableCellTop]}>
              <Text style={[styles.colSix, styles.tableRow]}>Masse</Text>
              <Text style={[styles.colSix, styles.tableCellLeft, styles.tableRow]}>{weight}g</Text>
            </View>
            <View style={[styles.row, styles.tableCellTop]}>
              <Text style={[styles.colSix, styles.tableRow]}>Länge x Breite x Höhe</Text>
              <Text style={[styles.colSix, styles.tableCellLeft, styles.tableRow]}>{length}mm x {width}mm x {height}mm</Text>
            </View>
          </View>
        </View>

        {/* Prozess */}
        <View style={[styles.section, styles.largeSpaceAbove]}>
          <Text style={[styles.paragraph, styles.bold]}>2.3 Aktueller oder erwarteter Wärmebehandlungsprozess</Text>
          <View style={styles.table}>
            <View style={styles.row}>
              <Text style={[styles.colSix, styles.tableRow]}>Energieträger aufheizen</Text>
              <Text style={[styles.colSix, styles.tableCellLeft, styles.tableRow]}>{zone1Energy}</Text>
            </View>
            <View style={[styles.row, styles.tableCellTop]}>
              <Text style={[styles.colSix, styles.tableRow]}>Energieträger Haltephase</Text>
              <Text style={[styles.colSix, styles.tableCellLeft, styles.tableRow]}>{zone2Energy}</Text>
            </View>
            <View style={[styles.row, styles.tableCellTop]}>
              <Text style={[styles.colSix, styles.tableRow]}>Starttemperatur</Text>
              <Text style={[styles.colSix, styles.tableCellLeft, styles.tableRow]}>{ambientTemp} °C</Text>
            </View>
            <View style={[styles.row, styles.tableCellTop]}>
              <Text style={[styles.colSix, styles.tableRow]}>Prozesstemperatur</Text>
              <Text style={[styles.colSix, styles.tableCellLeft, styles.tableRow]}>{processTemp} °C</Text>
            </View>
            <View style={[styles.row, styles.tableCellTop]}>
              <Text style={[styles.colSix, styles.tableRow]}>Dauer Prozessphase</Text>
              <Text style={[styles.colSix, styles.tableCellLeft, styles.tableRow]}>{holdTime}</Text>
            </View>
            <View style={[styles.row, styles.tableCellTop]}>
              <Text style={[styles.colSix, styles.tableRow]}>Dauer Aufheizphase</Text>
              <Text style={[styles.colSix, styles.tableCellLeft, styles.tableRow]}>{heatTime}</Text>
            </View>
          </View>
          <Image style={styles.smallSpaceAbove} src={processChartUrl} />
        </View>
      </Page>


      {/* Seite 6 Empfohlenes Ofenkonzept */}
      {renderCharts(idealHeatEvent, scoreChart, footprintChart, powerChartUrl, outputChartUrl, investChartUrl)}

      {/* Seite 7 Beschreibung Ofenkonzepte */}
      <Page style={[styles.page, styles.largeSpaceAbove]}>
        <View style={styles.section}>
          <Text style={styles.h2}>4 Beschreibung der Ofenkonzepte</Text>
          <Text style={[styles.paragraph, styles.bold]}>4.1 Durchlaufanlagen (Typ VDU)</Text>
          <Image src={durchlaufanlagen} />
          <Text style={styles.paragraph}>Der vötschtechnik® Durchlaufofen ist ein zuverlässiger Baustein in Ihrer Fertigungslinie. Er kann mit den verschiedensten Fördersystemen ausgestattet werden. Besonders geeignet ist er als Komponente für Wärmebehandlungen in Automatisationslinien. Unsere Durchlauföfen sind in Modularbauweise oder nach Kundenvorgaben erhältlich. Die Luftführung erfolgt horizontal, vertikal oder beidseitig einblasend. Bei der Modularbauweise sind unterschiedliche Nutzraumbreiten und -längen vorgesehen. Durch die Kopplung der Module wird die gewünschte Ofenlänge erzielt.</Text>
          <Text style={styles.paragraph}>Die Durchlaufanlagen von vötschtechnik® gehören durchweg zum Sondergerätebau. Sie sind auf die Anforderungen Ihres Anwendungsprozesses abgestimmt.</Text>
          <Text style={styles.paragraph}>Kundenvorteile auf einen Blick:</Text>
          <View style={styles.list}>
            <View style={styles.listEntry}>
              <Text style={styles.listPoint}>&bull;</Text>
              <Text>Optimal auf Ihre Produkte und Ihr Materialhandling abgestimmte Anlagentechnik </Text>
            </View>
            <View style={styles.listEntry}>
              <Text style={styles.listPoint}>&bull;</Text>
              <Text>Langlebig und zuverlässig für eine hohe Anlagenverfügbarkeit im 24/7 Betrieb</Text>
            </View>
            <View style={styles.listEntry}>
              <Text style={styles.listPoint}>&bull;</Text>
              <Text>Geringer Energieverbrauch durch IE3-Motoren, optimierte Heizleistung und Isolation sowie zuverlässige Türdichtungskonzepte </Text>
            </View>
          </View>
          <Text style={styles.paragraph}>Annahmen bei der Konzeption:</Text>
          <View style={styles.list}>
            <View style={styles.listEntry}>
              <Text style={styles.listPoint}>&bull;</Text>
              <Text>Längste Seite des Bauteils quer zur Transportrichtung</Text>
            </View>
            <View style={styles.listEntry}>
              <Text style={styles.listPoint}>&bull;</Text>
              <Text>Kürzeste Seite des Bauteils als Auflagefläche, ggf. mit Positionsierungshilfe an der Fördertechnik</Text>
            </View>
            <View style={styles.listEntry}>
              <Text style={styles.listPoint}>&bull;</Text>
              <Text>Reines Umluftsystem, kein Einsatz brennbarer Lösemittel möglich </Text>
            </View>
          </View>
        </View>
      </Page>

      {/* Seite 8 Beschreibung Ofenkonzepte */}
      <Page style={[styles.page, styles.largeSpaceAbove]}>
        <View style={styles.section}>
          <Text style={[styles.paragraph, styles.bold]}>4.2 Kammerofen (Typ HeatEvent)</Text>
          <Image src={heatevents} />
          <Text style={styles.paragraph}>Reproduzierbare Ergebnisse und die damit verbundene Produktqualität, minimaler Platzbedarf und kurze Prozesszeiten sowie hohe Produktivität sind die Anforderungen in jedem industriellen Produktionsbereich. Mit den vötschtechnik® Wärme- und Trockenschränken HeatEvent lassen sich Ihre Bauteile und Materialien zuverlässig, schnell und energieeffizient mit Temperaturen von bis zu 400 °C wärmebehandeln. So erhalten Sie exzellente Produkte - rund um die Uhr, sieben Tage die Woche, 365 Tage im Jahr.</Text>
          <Text style={styles.paragraph}>HeatEvent bietet das größte Nutzraumvolumen bei kleinstem Footprint und ist dank iE3-Motoren, einer verbesserten Isolation und dem zuverlässigen Türdichtungskonzept äußerst energieeffizient. Die Baureihe ist serienmäßig mit der smarten Steuerung S!MPAC® und der innovativen Bedienoberfläche WEBSeason® ausgestattet. Dies ermöglicht die einfache Bedienung und Überwachung des Wärme- und Trockenschranks, das Erstellung von komplexen Temperprogrammen und die Automatisierung von Prozessen, auch nach AMS 2750E und CQI-9. Das große Sicherheitspaket sorgt dafür, dass nichts anbrennt.</Text>
          <Text style={styles.paragraph}>Kundenvorteile auf einen Blick:</Text>
          <View style={styles.list}>
            <View style={styles.listEntry}>
              <Text style={styles.listPoint}>&bull;</Text>
              <Text>Kleinster Footprint bei größtem Nutzraumvolumen</Text>
            </View>
            <View style={styles.listEntry}>
              <Text style={styles.listPoint}>&bull;</Text>
              <Text>Geringer Energieverbrauch durch IE3-Motoren, optimierte Heizleistung und Isolation sowie zuverlässige Türdichtungskonzepte </Text>
            </View>
            <View style={styles.listEntry}>
              <Text style={styles.listPoint}>&bull;</Text>
              <Text>Weltweit größte Anzahl an Optionen und Zubehör bei umfassender Grundausstattung </Text>
            </View>
          </View>
        </View>
      </Page>

    </Document >
  )
}

const createPdf = async (name, firstName, motivationChart, scoreChart,
  sliderPoints, motivations, material, colors, surface, geometry,
  length, width, height, weight, quantity, zone1Energy, zone2Energy,
  processTemp, ambientTemp, heatTime, holdTime, processChartUrl, footprintChartUrl, powerChartUrl, outputChartUrl, investChartUrl, idealHeatEvent) => {
  const blob = await pdf(
    <PdfDocument
      name={name} firstName={firstName}
      motivationChart={motivationChart} scoreChart={scoreChart}
      footprintChart={footprintChartUrl}
      sliderPoints={sliderPoints} motivations={motivations}
      material={material} colors={colors}
      surface={surface} geometry={geometry}
      length={length} width={width} height={height} weight={weight}
      quantity={quantity} zone1Energy={zone1Energy} zone2Energy={zone2Energy}
      processTemp={processTemp} ambientTemp={ambientTemp} heatTime={heatTime} holdTime={holdTime}
      processChartUrl={processChartUrl} powerChartUrl={powerChartUrl} outputChartUrl={outputChartUrl} investChartUrl={investChartUrl} idealHeatEvent={idealHeatEvent} />
  ).toBlob();
  return blob
}

export { createPdf, PdfDocument }